<template>
  <div id="page-vessel-sort">
    <div  class="vx-card p-6">

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        class="ag-theme-material ag-grid-table"
        :gridOptions="gridOptions"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :components="components"
        rowSelection="multiple"
        colResizeDefault="shift"
        :floatingFilter="false"
        :enableRtl="$vs.rtl"
        :rowDragManaged="true"
        :animateRows="true"
        :suppressDragLeaveHidesColumns="true"
        :rowData="vessels"
      >
      </ag-grid-vue>

      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button
          id="button-with-loading"
          type="filled"
          @click="saveSort"
          class="mt-5 block"
          >登録する</vs-button
        >
        <vs-button
          type="border"
          class="mt-5 block"
          :to="{
            name: 'enterprise-management-vessel-list'
          }"
          >キャンセル</vs-button
        >
      </div>

    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import CellRendererDisableStatus from "./cell-renderer/CellRendererDisableStatus.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters} = createNamespacedHelpers("enterpriseVesselList");

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererDisableStatus,
  },
  data() {
    return {
      searchCondition: {
        name: "",
        name_ja: "",
        isDisabled: null,
        isDeleted: false, // 削除済は取得対象外
        page: 0,
        limit: 9999,
      },
      // AgGrid
      gridApi: null,
      gridOptions: {
        localeText: { noRowsToShow: "船舶が見つかりませんでした" },
        context: {
          componentParent: this
        },
        suppressCellSelection: true
      },
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: null,
      // Cell Renderer Components
      components: {},
    };
  },
  computed: {
    ...mapGetters({
      vessels : "getVesselsWithLabel"
    })
  },
  methods: {
    ...mapActions(["fetchVessels", "updateVesselsSortOrder", "resetVesselsListState"]),

    async searchVessels() {
      let payload = {
        id: this.searchCondition.id,
        name: this.searchCondition.name,
        name_ja: this.searchCondition.name_ja,
        is_disabled: this.searchCondition.isDisabled,
        is_deleted: this.searchCondition.isDeleted,
        page: this.searchCondition.page,
        limit: this.searchCondition.limit
      };
      this.$vs.loading();
      try {
        await this.fetchVessels(payload);
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    async saveSort() {

      let vesselsListData = this.gridApi.getModel().rowsToDisplay.map(displayRow => displayRow.data);
      let payload = {
        sort_orders:  vesselsListData.map((vessel, index) => {
                        return { enterprise_vessel_id: vessel.enterprise_vessel_id, sort_order: (index + 1) };
                      })
      };
      this.$vs.loading({
        type: "default",
        container: "#button-with-loading",
        scale: 0.45
      });
      try {
        await this.updateVesselsSortOrder(payload);
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "表示順序を更新しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$router.push({ name: "enterprise-management-vessel-list" });
      } catch (e) {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "表示順序の更新に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check"
        });
      }
    },
    cleanup() {
      this.resetVesselsListState()
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        rowDrag: true,
        headerName: "",
        width: 30,
        field: "label",
      },
      {
        headerName: "ID",
        field: "id",
        width: 110
      },
      {
        headerName: "船名",
        field: "label",
        width: 250
      },
      {
        headerName: "有効状況",
        field: "disabled_at",
        filter: true,
        width: 150,
        cellRenderer: "CellRendererDisableStatus"
      }
    ];
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }
  },
  created() {
    this.searchVessels();
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style lang="scss" scoped>
#page-vessel-sort {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-theme-material {
    height: calc(100vh - 360px);
  }
  .vs-button {
    margin:0.5rem;
  }
  .con-vs-avatar {
    cursor : auto;
  }
}
</style>

